
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'CombinationsTotalWidth',
})
export default class CombinationsTotalWidth extends Vue {
    @Prop({ type: Number, required: false, default: 0 }) readonly value!: number;
    @Prop({ type: Number, required: false, default: 0 }) readonly combinedWidth!: number;

    private updateTotalWidth(value: number | undefined): void {
        if (value === undefined) return;
        this.$emit('update', value);
    }
}
